import React from 'react';
import { motion } from 'framer-motion';

export default function SlideReveal({ 
  children, 
  direction = 'right', 
  duration = 0.8, 
  delay = 0, 
  bgGradient = 'linear-gradient(135deg, #6E53FF 0%, #FF5DA2 100%)',
  className = ''
}) {
  const variants = {
    hidden: {
      x: direction === 'right' ? '100%' : direction === 'left' ? '-100%' : 0,
      y: direction === 'up' ? '100%' : direction === 'down' ? '-100%' : 0,
      filter: 'blur(10px)',
    },
    visible: {
      x: 0,
      y: 0,
      filter: 'blur(0px)',
      transition: {
        duration: duration,
        ease: [0.25, 1, 0.5, 1], // Cubic bezier for smooth overshoot
        delay: delay,
      }
    },
    exit: {
      x: direction === 'right' ? '-100%' : direction === 'left' ? '100%' : 0,
      y: direction === 'up' ? '-100%' : direction === 'down' ? '100%' : 0,
      filter: 'blur(10px)',
      transition: {
        duration: duration * 0.8,
        ease: [0.25, 1, 0.5, 1]
      }
    }
  };

  return (
    <motion.div
      className={`absolute inset-0 w-full h-full overflow-hidden ${className}`}
      style={{ 
        background: bgGradient,
        willChange: 'transform, filter',
        zIndex: 10
      }}
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={variants}
    >
      {/* Curved masked leading edge simulation (optional visual flair) */}
      <div className="absolute inset-0 flex items-center justify-center p-8">
        {children}
      </div>
    </motion.div>
  );
}
